import React from 'react'
import PropTypes from 'prop-types'
import { getIn } from 'formik'
import TextEditorRaw from '~/components/common/ShortTextEditor'

const TextEditor = ({ field, form, disabled, ...props }) => (
  <TextEditorRaw
    {...field}
    name={field.name}
    error={
      !!getIn(form.touched, field.name) && !!getIn(form.errors, field.name)
    }
    helperText={
      getIn(form.touched, field.name) && getIn(form.errors, field.name)
    }
    onChange={(value) => form.setFieldValue(field.name, value)}
    disabled={disabled || !!form.values.__readOnly}
    {...props}
  />
)

TextEditor.defaultProps = {
  disabled: false,
}

TextEditor.propTypes = {
  form: PropTypes.shape().isRequired,
  field: PropTypes.shape().isRequired,
  disabled: PropTypes.bool,
}

export default TextEditor
